'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:travelmerchant:get_pos_deviceid');
}

var _invoke = require('../invoke');

/**
 * 获取pos 设备id
 *
 * @memberof travel
 * @static
 * @name getPosDeviceId
 * @return {Promise}
 * @example
 *  hbnb.travel.getPosDeviceId()
 *      .then(function(resp) {
 *          resp = {
 *              deviceid: "xxxxx"//如果返回deviceid为空，则表示不是pos机
 *          }
 *      });
 */
module.exports = function() {
    if (process.env.NODE_ENV !== 'production') {
        debug('getDeviceId  %s');
    }
    var p = new Promise(function(resolve, reject) {
        _invoke('travelmerchant', 'get_pos_deviceid', {
            callback: function(resp) {
                resolve(resp);
            },
            complete: function (resp) {
                reject(resp);
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/travel/biz-pos-device-id.js
// module id = 263
// module chunks = 10 11 12 13 14 15 16 17 18 19